import React from 'react';

import SVG from "react-inlinesvg";

// interface iSvgIcon {
//     icon: string,
//     keepColor?: boolean,
//     className?: string,
// }

// const SvgIcon = (props: iSvgIcon) => {
const SvgIcon = (props) => {

    const { icon, keepColor, className, ...others } = props;

    try {
        // const loadedSvg = require('../assets/' + props.icon + '.svg');
        const loadedSvg = require(`../assets/${props.icon}.svg`);

        return (
            <i className={'svg-icon svg-icon--' + icon + ' ' + className} {...others}>
                <SVG src={loadedSvg}
                    preProcessor={((code) => {
                        return !props.keepColor
                            ? code.replace(/fill:.*?;/g, 'fill:currentColor;')
                            : code;
                    })}
                />
            </i>
        );
    }
    catch (e) {
        console.log('icon missing: ' + props.icon)
        console.log(e)
    }

    return (
        <i className="svg-icon"><small>Icon missing</small></i>
    );
};

SvgIcon.defaultProps = {
    keepColor: false,
}

export default SvgIcon;